import { Link } from "react-router-dom";
import { useState } from "react";
import { videos, categories, hotTags } from "@/mocks/videos";

export default function LatestUpdates() {
  const [activeTag, setActiveTag] = useState<string | null>(null);

  const filtered = activeTag
    ? videos.filter((v) => v.tags.includes(activeTag))
    : videos;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              最新更新
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              全部影片
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              共 {videos.length} 部精彩影片等待您的发现
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {hotTags.map((tag) => (
            <button
              key={tag}
              onClick={() => setActiveTag(activeTag === tag ? null : tag)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                activeTag === tag
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((video) => {
            const cat = categories.find((c) => c.id === video.category);
            return (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group flex gap-4 p-3 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
                data-product-shop
              >
                <div className="relative w-40 sm:w-48 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src={video.coverImage}
                    alt={`${video.title} - 玫瑰视频`}
                    title={`${video.title} - 玫瑰视频免费在线观看`}
                    className="w-full aspect-video object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute bottom-2 right-2">
                    <span className="px-1.5 py-0.5 bg-black/75 text-background-50 text-[10px] rounded">
                      {video.duration}
                    </span>
                  </div>
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between py-1">
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                      {video.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                      {cat && (
                        <span className="text-[11px] text-foreground-400 bg-background-200 px-1.5 py-0.5 rounded">
                          {cat.name}
                        </span>
                      )}
                      <span className="text-[11px] text-foreground-400">{video.source}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="flex items-center gap-1 text-xs text-accent-500">
                      <i className="ri-star-fill text-[10px]"></i>
                      {video.rating}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {video.views}次播放
                    </span>
                    <span className="text-xs text-foreground-300">
                      {video.totalEpisodes > 1 ? `${video.totalEpisodes}集` : "电影"}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-10">
            <p className="text-foreground-400">暂无匹配的影片</p>
          </div>
        )}
      </div>
    </section>
  );
}